! function() {
    "use strict";
    class t extends HTMLElement {
        constructor() {
            super(), this.section = this.closest("product-info"), this.form = this.section.querySelector("[data-product-form]"), this.handleProductAddError = this.handleProductAddError.bind(this), this.boundSetCartBarHeight = this.setCartBarHeight.bind(this)
        }
        connectedCallback() {
            this.setCartBarHeight(), this.addEventListener("click", this.handleClick.bind(this)), document.addEventListener("theme:resize", this.boundSetCartBarHeight), document.addEventListener("theme:product:add-error", this.handleProductAddError), this.initAtcObserver()
        }
        handleClick(t) {
            const e = t.target.closest("[data-cart-bar-add-to-cart]");
            e && (t.preventDefault(), e.classList.add("is-loading"), e.setAttribute("disabled", "disabled"), this.form.closest("product-form").onSubmitHandler(t));
            t.target.closest("[data-cart-bar-scroll]") && (t.preventDefault(), this.scrollToTop())
        }
        handleProductAddError() {
            this.querySelector("[data-cart-bar-add-to-cart]") && this.scrollToTop()
        }
        scrollToTop() {
            const t = this.section.querySelector("variant-selects"),
                e = (theme.isMobile ? t || this.form : this.section).getBoundingClientRect().top;
            window.theme.scrollTo(theme.isMobile ? e - 10 : e)
        }
        initAtcObserver() {
          const t = this.section.querySelector('[type="submit"][name="add"],[data-add-to-cart]');
          t && (this.atcObserver = new IntersectionObserver((t => {
              t.forEach((t => {
                  this.classList.toggle("is-visible", !t.isIntersecting && t.boundingClientRect.top < 0)
              }))
          }), {
              threshold: 0
          }), this.atcObserver.observe(t))
        }
        setCartBarHeight() {
            const t = this.offsetHeight;
            document.documentElement.style.setProperty("--cart-bar-height", `${t}px`)
        }
        disconnectedCallback() {
            document.removeEventListener("theme:product:add-error", this.handleProductAddError), document.removeEventListener("theme:resize", this.boundSetCartBarHeight), this.atcObserver && this.atcObserver.disconnect()
        }
    }
    customElements.get("cart-bar") || customElements.define("cart-bar", t)
}();